import GeneralView from '~/generalView';
import Handlebars from 'handlebars';
import Settings from '~/settings.js';
import toastr from 'toastr';
import EventHub from '~/eventHub';
import useradd_template from '~/templates/useradd.handlebars';
import getUtilsService from '~/services/utilsService';
var UseraddView = GeneralView.View.extend({
	tagName: "div",
	className: 'User',
	userId:'',
	users: '',
	user: null,
	params: {},
	events: {
		'click #create-user':'createUser',
		'click #manualpassword' : 'togglePassword'
	},
	
	togglePassword :function(){
		if($('#manualpassword')[0].checked) {
			$(".password-container").show();
		}
		else {
			$(".password-container").hide();
		}
	},
	
    render: function () {
		var that = this;
		toastr.options = {
			"closeButton": true,
			"debug": false,
			"newestOnTop": true,
			"progressBar": false,
			"positionClass": "toast-top-center",
			"preventDuplicates": false,
			"onclick": null,
			"showDuration": "300",
			"hideDuration": "1000",
			"timeOut": "5000",
			"extendedTimeOut": "1000",
			"showEasing": "swing",
			"hideEasing": "linear",
			"showMethod": "fadeIn",
			"hideMethod": "fadeOut"
		}
		var permissions = getUtilsService.getprofilepermissions();
		if (Settings.shogunmonitorapp && !permissions.accessallreports) {
			that.params.shogunmonitorapp = true;
		};
		Parse.Cloud.run("getallusers", that.params).then(allusers => {
			that.users = allusers;
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
		this.attachEvents();
		$('#myModal').hide();
		$('.modal-backdrop').hide();
		return this;
	},
	
	attachEvents: function() {
		var that = this;
		var handlebarsTemplate = Handlebars.template(useradd_template);
		this.$el.html(handlebarsTemplate());
		var link = { url:'Perfil de Usuario'};
		this.$el.find('.content').hide();
		this.translate();
		Parse.Cloud.run("getroles", that.params).then((roles) => {
			var vroles = [];
			vroles.models = roles;
			var handlebarsTemplate = Handlebars.template(useradd_template);
			this.$el.html(handlebarsTemplate(vroles));
			this.roles = [];
			this.roles = vroles;
			this.$el.find('.useraddloader').hide();
			this.$el.find('header-tittle').val('link.url');
			this.$el.find('#data-field-username').fadeOut('fast');
			this.$el.find('#editor-field-username').show('fast');
			this.$el.find('#data-field-email').fadeOut('fast');
			this.$el.find('#editor-field-email').show('fast');
			this.$el.find('#data-field-name').fadeOut('fast');
			this.$el.find('#editor-field-name').show('fast');
			this.$el.find('#data-field-lastname').fadeOut('fast');
			this.$el.find('#editor-field-lastname').show('slow');
			this.$el.find('#data-field-gender').fadeOut('fast');
			this.$el.find('#editor-field-gender').show('fast');
			this.$el.find('#change-pass').fadeOut('fast');
			this.$el.find('#change-password').show('fast');
			if (Settings.shogunmonitorapp && Parse.User.current().attributes.role == 'Administrador General') {
				this.$el.find('.adduserclientname').show('fast');
				this.$el.find('#editor-field-client').show('fast');
			}
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},
	
	createUser: function(){
		var that = this;
		var user = new Parse.User();
		var username = this.$el.find('#inputusername').val().toLowerCase();
		var email = this.$el.find('#input-email').val().toLowerCase();
		user.set("username", username);
		user.set("email", email);
		user.set("email2", email);
		var validatepass = true;
		if($('#manualpassword')[0].checked) {
			let passw = new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\w~@#$%^&*+=`|{}:;!.?\"()\[\]-]{8,24}$/);
			if($('#inputpassword').val().match(passw)) {
				user.set("password", $('#inputpassword').val());
				user.set("passtext", $('#inputpassword').val());
				user.set("manual_password", true);
			}
			else {
				validatepass = false;
			}
		}
		else {
			user.set("password", "&");
		}
		if (validatepass) {
			var createuser = true;
			if(Settings.shogunmonitorapp ) {
				user.set("supercategory", this.$el.find('#input-client').val());
				if (Parse.User.current().attributes.role != 'Administrador General') {
					createuser = true;
					user.set("supercategory", Parse.User.current().attributes.supercategory);
				}
				if (that.users.length == 2) {
					createuser = false;
				}
			}
			if (createuser) {
				user.set("role", this.$el.find('#input-rol').val());
				var sessionToken = Parse.User.current()._sessionToken;
				user.save(null, {
					success: function (user) {
						if(lang!= undefined && lang !='es') {
							toastr.success(arrlang[lang]["UserCreated"]);
						}
						else {
							toastr.success("Usuario creado");
						}
						that.render();
					},
					error: function (user, error) {
						console.log(error);
						switch(error.code){
							case 202:
								toastr.error('Usuario ya existe','Error al crear usuario.');
							break;
							case 100:
								toastr.error(arrlang[lang]['InternetConnectionError'],'Error al crear usuario.');
							break;
							default:
								if(arrlang[lang][error.message]){
									toastr.error(arrlang[lang][error.message]);
								}
								else{
									toastr.error('Error al crear usuario.');
								}
							break;
						}
					}
				});
			}
			else {
				toastr.warning('Usuario no creado','Maximo de Usuarios alcanzado.');
			}
		}
		else {
			toastr.warning('La contraseña debe ser igual o mayor a 8 caracteres, igual o menor a 24 caracteres y tener al menos una minúscula, una mayúscula y un número.','Error al crear usuario.');
		}
	},
});
/**
 *
 * Module profileView
 * @module views/profileView
 * @returns ParseService
 */
export default UseraddView;
